import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { background, brandPrimary, header, label } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const { spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		maxWidth: 600,
		alignItems: 'center',
		paddingLeft: 200,
		paddingRight: 200,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: common.border,
	},
	tabViewItem: {
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: 14,
		height: spacing.xxl,
		padding: `${spacing.none} ${spacing.xl}px`,
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: spacing.sm,
	},
	tabItemSelected: {
		borderBottom: `1px solid ${brandPrimary}`,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
		padding: spacing.md,
	},
	signInContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
	},
	signInForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	inputWrapper: {},
	signInFormFieldLabel: {
		color: label,
		fontSize: 14,
	},
	signInFormField: {
		display: 'flex',
		margin: spacing.sm,
		width: 300,
	},
	textInput: {
		width: '100%',
	},
	inProgressIconContainer: {
		...CssSelectors.allChildren({
			marginTop: spacing.xl,
			opacity: 0.15,
		}),
		background,
		borderRadius: '50%',
		height: 180,
		margin: '30px auto 40px',
		textAlign: 'center',
		width: 180,
	},
});
